export default __webpack_public_path__ + "static/media/YchooseRL.0c7d17ea.png";